/* eslint-disable @typescript-eslint/no-explicit-any */
import Barcode from 'react-barcode';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';

import logo from 'assets/img/icons/rizomarketplace-logo.png';
import './styles.scss';
import { useAppContext } from 'providers/AppProvider';

interface PriceListFilterProps {
  activeCard?: any;
  setActiveCard?: any;
  hidePrice?: any;
  hideBarcode?: any;
  selectPriceWhosale?: any;
}

const PriceListCards = forwardRef(
  ({
    activeCard,
    setActiveCard,
    hidePrice,
    hideBarcode,
    selectPriceWhosale
  }: PriceListFilterProps) => {
    const {
      config: { theme }
    } = useAppContext();
    const legalEntityName = useSelector(
      (state: any) => state?.auth?.legal_entity?.name
    );

    const logoUrl = useSelector(
      (state: any) => state?.auth?.legal_entity?.logo_url
    );

    const logoType = `${process.env.REACT_APP_CDN_URL}${logoUrl}`;

    const handleCardClick = (card: any) => {
      setActiveCard(card);
    };

    return (
      <div className="my-product-main-container">
        <div
          /* prettier-ignore */
          className={`card-60-40 ${activeCard === 'card-60-40' ? 'active' : ''}`}
          onClick={() => handleCardClick('card-60-40')}
        >
          <p className="size-title">60 X 40 mm</p>

          <div className="card-body">
            <div className="logo">
              <img src={logoType ? logoType : logo} alt="logo" />
            </div>

            <div className="body-items">
              <p className="filial">
                {legalEntityName ? legalEntityName : 'FILIAL STANDART'}
              </p>
              <p className="title">Orbit Mint Fresh</p>

              <div className="cost-box">
                <span className={hideBarcode ? 'cost-changed' : 'cost'}>
                  {selectPriceWhosale ? (
                    hidePrice ? (
                      <div style={{ height: '18px' }}></div>
                    ) : (
                      '5 000'
                    )
                  ) : hidePrice ? (
                    <div style={{ height: '18px' }}></div>
                  ) : (
                    '6 000'
                  )}
                </span>

                <div
                  className={
                    hideBarcode ? 'cost-divider-changed' : 'cost-divider'
                  }
                >
                  {hidePrice ? (
                    ''
                  ) : (
                    <>
                      <span className="top">00</span>
                      <span className="bottom">UZS</span>
                    </>
                  )}
                </div>
              </div>

              {hideBarcode ? (
                <div style={{ height: '28px' }}></div>
              ) : (
                <Barcode
                  value="40099507"
                  width={1.4}
                  height={hidePrice ? 40 : 20}
                  format="CODE128"
                  displayValue={true}
                  font="monospace"
                  fontSize={12}
                  background="transparent"
                  lineColor={`${theme === 'dark' ? '#fff' : '#000'}`}
                />
              )}
            </div>

            <span className="scale-code">(001)</span>
          </div>
        </div>

        <div
          /* prettier-ignore */
          className={`card-58-30 ${activeCard === 'card-58-30' ? 'active' : ''}`}
          onClick={() => handleCardClick('card-58-30')}
        >
          <p className="size-title">58 X 30 mm</p>

          <div className="card-body">
            <div className="body-items">
              <p className="filial">
                {legalEntityName ? legalEntityName : 'FILIAL STANDART'}
              </p>
              <p className="title">Orbit Mint Fresh</p>

              <div className="cost-box">
                <span className={hideBarcode ? 'cost-changed' : 'cost'}>
                  {selectPriceWhosale ? (
                    hidePrice ? (
                      <div style={{ height: '12px' }}></div>
                    ) : (
                      '5 000'
                    )
                  ) : hidePrice ? (
                    <div style={{ height: '12px' }}></div>
                  ) : (
                    '6 000'
                  )}
                </span>

                <div
                  className={
                    hideBarcode ? 'cost-divider-changed' : 'cost-divider'
                  }
                >
                  {hidePrice ? (
                    ''
                  ) : (
                    <>
                      <span className="top">00</span>
                      <span className="bottom">UZS</span>
                    </>
                  )}
                </div>
              </div>

              {hideBarcode ? (
                <div style={{ height: '22px' }}></div>
              ) : (
                <Barcode
                  value="40099507"
                  height={hidePrice ? 40 : 18}
                  format="CODE128"
                  displayValue={true}
                  font="monospace"
                  fontSize={10}
                  background="transparent"
                  lineColor={`${theme === 'dark' ? '#fff' : '#000'}`}
                />
              )}
            </div>

            <span className="scale-code">(001)</span>
          </div>
        </div>

        <div
          /* prettier-ignore */
          className={`card-40-30 ${activeCard === 'card-40-30' ? 'active' : ''}`}
          onClick={() => handleCardClick('card-40-30')}
        >
          <p className="size-title">40 X 30 mm</p>

          <div className="card-body">
            <div className="body-items">
              <p className="filial">
                {legalEntityName ? legalEntityName : 'FILIAL STANDART'}
              </p>
              <p className="title">Orbit Mint Fresh</p>

              <div className="cost-box">
                <span className={hideBarcode ? 'cost-changed' : 'cost'}>
                  {selectPriceWhosale ? (
                    hidePrice ? (
                      <div style={{ height: '12px' }}></div>
                    ) : (
                      '5 000'
                    )
                  ) : hidePrice ? (
                    <div style={{ height: '12px' }}></div>
                  ) : (
                    '6 000'
                  )}
                </span>

                <div
                  className={
                    hideBarcode ? 'cost-divider-changed' : 'cost-divider'
                  }
                >
                  {hidePrice ? (
                    ''
                  ) : (
                    <>
                      <span className="top">00</span>
                      <span className="bottom">UZS</span>
                    </>
                  )}
                </div>
              </div>

              {hideBarcode ? (
                <div style={{ height: '24px' }}></div>
              ) : (
                <Barcode
                  value="40099507"
                  width={1.3}
                  height={hidePrice ? 30 : 18}
                  format="CODE128"
                  displayValue={true}
                  font="monospace"
                  fontSize={10}
                  background="transparent"
                  lineColor={`${theme === 'dark' ? '#fff' : '#000'}`}
                />
              )}
            </div>
          </div>
        </div>

        <div
          /* prettier-ignore */
          className={`card-30-20 ${activeCard === 'card-30-20' ? 'active' : ''}`}
          onClick={() => handleCardClick('card-30-20')}
        >
          <p className="size-title">30 X 20 mm</p>

          <div className="card-body">
            <div className="body-items">
              <p className="title">Orbit Mint Fresh</p>

              <div className="cost-box">
                <span className={hideBarcode ? 'cost-changed' : 'cost'}>
                  {selectPriceWhosale ? (
                    hidePrice ? (
                      <div style={{ height: '12px' }}></div>
                    ) : (
                      '5 000'
                    )
                  ) : hidePrice ? (
                    <div style={{ height: '12px' }}></div>
                  ) : (
                    '6 000'
                  )}
                </span>

                <div
                  className={
                    hideBarcode ? 'cost-divider-changed' : 'cost-divider'
                  }
                >
                  {hidePrice ? (
                    ''
                  ) : (
                    <>
                      <span className="top">00</span>
                      <span className="bottom">UZS</span>
                    </>
                  )}
                </div>
              </div>

              {hideBarcode ? (
                <div style={{ height: '10px' }}></div>
              ) : (
                <Barcode
                  value="40099507"
                  width={1}
                  height={hidePrice ? 20 : 10}
                  format="CODE128"
                  displayValue={true}
                  font="monospace"
                  fontSize={8}
                  background="transparent"
                  lineColor={`${theme === 'dark' ? '#fff' : '#000'}`}
                />
              )}
            </div>
          </div>
        </div>

        <div
          /* prettier-ignore */
          className={`card-line-58-30 ${activeCard === 'card-line-58-30' ? 'active' : ''}`}
          onClick={() => handleCardClick('card-line-58-30')}
        >
          <p className="size-title">58 X 30 mm</p>

          <div className="card-body">
            <div className="body-items">
              <p className="title">Orbit Mint Fresh</p>

              <div className="cost-box">
                <span className={hideBarcode ? 'cost-changed' : 'cost'}>
                  {selectPriceWhosale ? (
                    hidePrice ? (
                      <div style={{ height: '12px' }}></div>
                    ) : (
                      '5 000'
                    )
                  ) : hidePrice ? (
                    <div style={{ height: '12px' }}></div>
                  ) : (
                    '6 000'
                  )}
                </span>
                <span className={hideBarcode ? 'bottom-changed' : 'bottom'}>
                  {hidePrice ? '' : 'UZS'}
                </span>
              </div>

              {hideBarcode ? (
                <div style={{ height: '20px' }}></div>
              ) : (
                <Barcode
                  value="40099507"
                  height={hidePrice ? 35 : 18}
                  format="CODE128"
                  displayValue={true}
                  font="monospace"
                  fontSize={10}
                  background="transparent"
                  lineColor={`${theme === 'dark' ? '#fff' : '#000'}`}
                />
              )}
            </div>
          </div>
        </div>

        <div
          /* prettier-ignore */
          className={`card-line-40-30 ${activeCard === 'card-line-40-30' ? 'active' : ''}`}
          onClick={() => handleCardClick('card-line-40-30')}
        >
          <p className="size-title">40 X 30 mm</p>

          <div className="card-body">
            <div className="body-items">
              <p className="title">Orbit Mint Fresh</p>

              <div className="cost-box">
                <span className={hideBarcode ? 'cost-changed' : 'cost'}>
                  {selectPriceWhosale ? (
                    hidePrice ? (
                      <div style={{ height: '12px' }}></div>
                    ) : (
                      '5 000'
                    )
                  ) : hidePrice ? (
                    <div style={{ height: '12px' }}></div>
                  ) : (
                    '6 000'
                  )}
                </span>
                <span className={hideBarcode ? 'bottom-changed' : 'bottom'}>
                  {hidePrice ? '' : 'UZS'}
                </span>
              </div>

              {hideBarcode ? (
                <div style={{ height: '26px' }}></div>
              ) : (
                <Barcode
                  value="40099507"
                  width={1.3}
                  height={hidePrice ? 30 : 18}
                  format="CODE128"
                  displayValue={true}
                  font="monospace"
                  fontSize={10}
                  background="transparent"
                  lineColor={`${theme === 'dark' ? '#fff' : '#000'}`}
                />
              )}
            </div>
          </div>
        </div>

        <div
          /* prettier-ignore */
          className={`card-line-def-58-30 ${activeCard === 'card-line-def-58-30' ? 'active' : ''}`}
          onClick={() => handleCardClick('card-line-def-58-30')}
        >
          <p className="size-title">58 X 30 mm</p>

          <div className="card-body">
            <div className="body-items">
              <p className="title">Orbit Mint Fresh</p>

              <div className="cost-box">
                <span className={'cost'}>
                  {selectPriceWhosale ? (
                    hidePrice ? (
                      <div style={{ height: '12px' }}></div>
                    ) : (
                      '5 000'
                    )
                  ) : hidePrice ? (
                    <div style={{ height: '12px' }}></div>
                  ) : (
                    '6 000'
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          /* prettier-ignore */
          className={`card-70-40 ${activeCard === 'card-70-40' ? 'active' : ''}`}
          onClick={() => handleCardClick('card-70-40')}
        >
          <p className="size-title">70 X 40 mm</p>

          <div className="card-body">
            <div className="logo">
              <img src={logoType ? logoType : logo} alt="logo" />
            </div>

            <div className="body-items">
              <p className="filial">
                {legalEntityName ? legalEntityName : 'FILIAL STANDART'}
              </p>
              <p className="title">Orbit Mint Fresh</p>

              <div className="cost-box">
                <span className={hideBarcode ? 'cost-changed' : 'cost'}>
                  {selectPriceWhosale ? (
                    hidePrice ? (
                      <div style={{ height: '18px' }}></div>
                    ) : (
                      '5 000'
                    )
                  ) : hidePrice ? (
                    <div style={{ height: '18px' }}></div>
                  ) : (
                    '6 000'
                  )}
                </span>

                <div
                  className={
                    hideBarcode ? 'cost-divider-changed' : 'cost-divider'
                  }
                >
                  {hidePrice ? (
                    ''
                  ) : (
                    <>
                      <span className="top">00</span>
                      <span className="bottom">UZS</span>
                    </>
                  )}
                </div>
              </div>

              {hideBarcode ? (
                <div style={{ height: '28px' }}></div>
              ) : (
                <Barcode
                  value="40099507"
                  width={1.4}
                  height={hidePrice ? 40 : 20}
                  format="CODE128"
                  displayValue={true}
                  font="monospace"
                  fontSize={12}
                  background="transparent"
                  lineColor={`${theme === 'dark' ? '#fff' : '#000'}`}
                />
              )}
            </div>

            <span className="scale-code">(001)</span>
          </div>
        </div>

        <div
          /* prettier-ignore */
          className={`card-line-def-70-40 ${activeCard === 'card-line-def-70-40' ? 'active' : ''}`}
          onClick={() => handleCardClick('card-line-def-70-40')}
        >
          <p className="size-title">70 X 40 mm</p>

          <div className="card-body">
            <div className="body-items">
              <p className="title">Orbit Mint Fresh</p>

              <div className="cost-box">
                <span className={'cost'}>
                  {selectPriceWhosale ? (
                    hidePrice ? (
                      <div style={{ height: '12px' }}></div>
                    ) : (
                      '5 000'
                    )
                  ) : hidePrice ? (
                    <div style={{ height: '12px' }}></div>
                  ) : (
                    '6 000'
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default PriceListCards;
